import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '@/app/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { isCyanApiRequest } from '../../environments/environment.model';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const isCyanApi = isCyanApiRequest(req.url, environment.apiUrl);

    if (!isCyanApi) {
        return next(req);
    }

    const withCredentials = req.clone({
        withCredentials: true
    });

    return next(withCredentials).pipe(
        catchError((error: HttpErrorResponse) => {
            const isRefreshRequest = req.url.includes('/auth/refresh');
            const isLoginRequest = req.url.includes('/auth/login');
            const isLogoutRequest = req.url.includes('/auth/logout');
            const isCurrentUserRequest = req.url.includes('/auth/me');

            if (
                error.status !== 401 ||
                isRefreshRequest ||
                isLoginRequest ||
                isLogoutRequest ||
                isCurrentUserRequest
            ) {
                return throwError(() => error);
            }

            return auth.refreshToken().pipe(
                switchMap(() => next(withCredentials)),
                catchError((refreshError) => {
                    auth.resetSession();
                    void router.navigate(['/login']);
                    return throwError(() => refreshError);
                })
            );
        })
    );
};
